var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';
import moment from 'moment';
import { createColumnHelper } from '@tanstack/react-table';
import { Tooltip } from 'flowbite-react';
import { Pill, Button } from "../../../../Components/UI";

import { Translate } from "../../../../../I18N";



const ActionHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Action");
const UserHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "User");
const DescriptionHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Description");
const TimeHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Timestamp");

const columnHelper = createColumnHelper();


const methodColors = new Map([
['CREATE', 'green'],
['UPDATE', 'blue'],
['DELETE', 'red'],
['RAW', 'gray'],
['MIGRATE', 'primary'],
['WARNING', 'yellow']]
);

const ActionPill = ({ action, className = '' }) => {
  const color = methodColors.get(action) || 'gray';
  return (/*#__PURE__*/
    _jsx(Pill, { className: `${className || ''} `, color: color }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, action)
    ));

};
const ActionCell = ({ cell }) => /*#__PURE__*/
_jsx(ActionPill, { action: cell.row.original.semantic.action });


const UserCell = ({ cell }) => /*#__PURE__*/
_jsx("span", { className: "text-primary-700" }, void 0, cell.getValue());


const DescriptionCell = ({ cell }) => {
  const semanticData = cell.getValue();

  return (/*#__PURE__*/
    _jsx("div", { className: "flex" }, void 0, /*#__PURE__*/
    _jsx(Tooltip
    // eslint-disable-next-line react/style-prop-object
    , { style: "light",
      className: "max-w-lg max-h-64 min-w-20",
      content: /*#__PURE__*/
      _jsx("div", { className: "flex-col" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "gap-4 w-full max-h-16" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Query"), /*#__PURE__*/
      _jsx("span", { className: "block overflow-hidden text-ellipsis" }, void 0, cell.row.original.query)
      ), /*#__PURE__*/
      _jsx("div", { className: "gap-4 w-full max-h-48" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Body"), /*#__PURE__*/
      _jsx("span", { className: "block overflow-hidden max-h-40 text-ellipsis" }, void 0,
      cell.row.original.body
      )
      )
      ) }, void 0,


    semanticData.action !== 'RAW' && /*#__PURE__*/
    _jsx("div", { className: "space-x-2" }, void 0,
    semanticData.description && /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx(Translate, { className: "font-semibold" }, void 0, semanticData.description), ":"
    ),

    semanticData.name && /*#__PURE__*/_jsx(Translate, {}, void 0, semanticData.name),
    semanticData.extra && /*#__PURE__*/_jsx(Translate, {}, void 0, semanticData.extra)
    ),

    semanticData.action === 'RAW' && /*#__PURE__*/
    _jsx("div", { className: "space-x-2" }, void 0, /*#__PURE__*/
    _jsx(Translate, { className: "font-semibold" }, void 0, cell.row.original.method), /*#__PURE__*/
    _jsx(Translate, {}, void 0, cell.row.original.url)
    )

    )
    ));

};

const TimeCell =
(dateFormat) =>
({ cell }) => {
  const date = moment(cell.getValue());
  return (/*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx("span", { className: "font-semibold" }, void 0, date.format(dateFormat.toUpperCase())), /*#__PURE__*/
    _jsx("span", { className: "font-medium" }, void 0, "\xA0-\xA0", date.format('hh:mm A'))
    ));

};

const ViewCell = ({ cell, column }) => /*#__PURE__*/
_jsx(Button, {
  styling: "light",
  className: "leading-4",
  onClick: async () => {var _column$columnDef$met, _column$columnDef$met2;return (_column$columnDef$met = column.columnDef.meta) === null || _column$columnDef$met === void 0 ? void 0 : (_column$columnDef$met2 = _column$columnDef$met.action) === null || _column$columnDef$met2 === void 0 ? void 0 : _column$columnDef$met2.call(_column$columnDef$met, cell.row);} }, void 0, /*#__PURE__*/

_jsx(Translate, {}, void 0, "View")
);


const getActivityLogColumns = (setSelectedEntry, dateFormat) => [
columnHelper.accessor('method', {
  header: ActionHeader,
  cell: ActionCell,
  meta: { headerClassName: 'text-center w-1/12' }
}),
columnHelper.accessor('username', {
  header: UserHeader,
  cell: UserCell,
  meta: { headerClassName: 'text-center w-2/12' }
}),
columnHelper.accessor('semantic', {
  header: DescriptionHeader,
  cell: DescriptionCell,
  enableSorting: false,
  meta: { headerClassName: 'text-center w-6/12' }
}),
columnHelper.accessor('time', {
  header: TimeHeader,
  cell: TimeCell(dateFormat),
  meta: { headerClassName: 'text-center w-2/12' }
}),
columnHelper.accessor('_id', {
  header: () => null,
  cell: ViewCell,
  meta: {
    action: setSelectedEntry,
    headerClassName: 'sr-only invisible bg-gray-50 w-1/12',
    contentClassName: 'text-center w-1/12'
  }
})];


export { getActivityLogColumns, ActionPill };